// SPDX-FileCopyrightText: 2017-2025 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

// GENERATED FILE: no manual modifications

/**
* Generated from fi.espoo.evaka.setting.SettingType
*/
export const settings = [
  'DECISION_MAKER_NAME',
  'DECISION_MAKER_TITLE'
] as const

export type SettingType = typeof settings[number]
